<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messagesError"
                               :error="isError"
                               :messagesChampsVide="messagesChampsVide"
                               :champsVide="champsVide"
                               :title="'addEditCivilite.error.problemOccurred'"
                               :withEmplyFields="true"
                               @close="isError = $event"/>
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
        {{ $t('detailContrat.renouvellement.popupNonRenouvellement.title') }}
        </p>
      </section>
      <section class="mgt-10px" v-if="isNonRenouvellement">
        <b-field :label="$t('detailContrat.renouvellement.contrat.motifNonRenouvellement')"
          class="mgt-20px" :type="isError ? 'is-danger' : ''">
          <b-input type="textarea" rows="4"
              v-model="motifNonRenouvellement">
          </b-input>
        </b-field>
      </section>
      <footer class="mgt-10px">
        <div class="has-text-centered">
          <qd-button
              class="button btn-modal-annuler is-cancel has-text-centered button-modal"
              @click="$parent.close()">
              {{ $t('general.non') }}
          </qd-button>
          <qd-button class="button is-primary has-text-centered button-modal"
                  :disabled="isError"
                  @click="popPrevention = true">
              {{ $t('general.oui') }}
          </qd-button>
        </div>
      </footer>
    </div>
    <b-modal v-model="popPrevention" class="modal">
      <pop-up-prevention
        :messHeader="$t('detailContrat.renouvellement.popupNonRenouvellement.confirmation')"
        messFooter=""
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popPrevention = false"
        @yes="nonRenouvellement()"
      />
    </b-modal>
  </div>
</template>
<script>
import { updateEtatRenouvellements } from '@/api/baux/contrat';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/baux/contrat/translatorContrat';
import { ETAT_NONRENOUVELEE } from '@/configuration/devisConf';
import popUpPrevention from '@/components/general/popUpPrevention';

export default {
  props: {
    contrats: {
      type: Array,
      required: true,
    },
    etatRenouvellement: {
      type: String,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    popUpPrevention,
  },
  data() {
    return {
      motifNonRenouvellement: '',
      messagesChampsVide: [],
      champsVide: [],
      isError: false,
      messagesError: [],
      popPrevention: false,
      constantes: {
        ETAT_NONRENOUVELEE,
      },
    };
  },
  computed: {
    isNonRenouvellement() {
      return this.etatRenouvellement === this.constantes.ETAT_NONRENOUVELEE;
    },
  },
  methods: {
    async nonRenouvellement() {
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateEtatRenouvellements({
          contratIds: this.contrats.map(contrat => contrat.id),
          etatRenouvellement: this.etatRenouvellement,
          motifNonRenouvellement: this.motifNonRenouvellement,
        });
        messageSucces(
          this.$i18n.t('detailContrat.renouvellement.popupNonRenouvellement.successNonRenouvellement'));
        this.$emit('reload');
        this.$parent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesError, this.messagesChampsVide, translate);
          this.isError = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.popPrevention = false;
        loadingComponent.close();
      }
    },
  },
};
</script>
